
import { createDemoRound, DEMO_ROUND_SIZE } from '~/utils/dating-demo'

export default {
  props: {
    copy: { type: Object, required: true },
    locale: { type: String, default: 'pl' },
    joinPath: { type: String, required: true },
    member: { type: Boolean, default: false }
  },
  data () {
    return { stage: 'setup', identity: 'man', seeking: 'woman', age: 30, profiles: [], reactions: [], ready: false, locked: false, unlockTimer: null }
  },
  computed: {
    identities () { return [{ value: 'woman', label: this.copy.woman }, { value: 'man', label: this.copy.man }] },
    audiences () { return [{ value: 'woman', label: this.copy.women }, { value: 'man', label: this.copy.men }, { value: 'everyone', label: this.copy.everyone }] },
    roundSize () { return DEMO_ROUND_SIZE },
    position () { return this.reactions.length },
    currentProfile () { return this.profiles[this.position] },
    likedCount () { return this.reactions.filter(reaction => reaction.liked).length },
    progressLabel () { return this.copy.cardOf.replace('{current}', this.position + 1).replace('{total}', this.roundSize) },
    status () {
      if (this.stage === 'cards') return this.progressLabel + '. ' + this.currentProfile.name + ', ' + this.currentProfile.age
      return this.stage === 'result' ? this.copy.resultHeading : ''
    }
  },
  mounted () { this.ready = true },
  beforeDestroy () { clearTimeout(this.unlockTimer) },
  methods: {
    identityChanged () { this.seeking = this.identity === 'man' ? 'woman' : 'man' },
    focusHeading () { this.$nextTick(() => { if (this.$refs.heading) this.$refs.heading.focus({ preventScroll: true }) }) },
    start () {
      if (!this.$refs.form.reportValidity()) return
      const profiles = createDemoRound({ age: this.age, seeking: this.seeking })
      if (profiles.length !== this.roundSize) return
      this.profiles = profiles
      this.reactions = []
      this.stage = 'cards'
      this.focusHeading()
      // Only static demo assets are fetched. No user or reaction endpoint is called.
      this.profiles.forEach(profile => { const image = new Image(); image.src = profile.image })
    },
    react (liked) {
      if (this.locked || this.stage !== 'cards' || !this.currentProfile) return
      this.locked = true
      this.reactions.push({ id: this.currentProfile.id, liked })
      if (this.position === this.roundSize) {
        this.stage = 'result'
        this.focusHeading()
      }
      this.unlockTimer = setTimeout(() => { this.locked = false }, 240)
    },
    reset () {
      clearTimeout(this.unlockTimer)
      this.locked = false
      this.stage = 'setup'
      this.profiles = []
      this.reactions = []
      this.focusHeading()
    }
  }
}
